import React from 'react';

import Icon, { IconProp } from '~components/icon';

interface ComponentProps {
  colSpan: number;
  message?: string;
  icon?: IconProp;
}

const TableEmpty: React.FC<ComponentProps> = ({ colSpan, message = 'No data available', icon }) => {
  return (
    <tr>
      <td colSpan={colSpan} className="empty">
        {icon && <Icon icon={icon} className="mb-3" size="2x" />}
        <div>{message}</div>
      </td>
    </tr>
  );
};

export default TableEmpty;
